import API, { GET_AUTH } from 'base/api';
import { fetchAllRooms } from './getRooms';

export const DELETE_ROOM = 'DELETE_ROOM';
export const DELETE_ROOM_BEGIN = 'DELETE_ROOM_BEGIN';
export const DELETE_ROOM_SUCCESS = 'DELETE_ROOM_SUCCESS';
export const DELETE_ROOM_ERROR = 'DELETE_ROOM_ERROR';

export const deleteRoomBegin = () => ({
  type: DELETE_ROOM_BEGIN
});

export const deleteRoomSuccess = ( data ) => ({
  type: DELETE_ROOM_SUCCESS,
  payload: { data }
});

export const deleteRoomError = ( error ) => ({
  type: DELETE_ROOM_ERROR,
  payload: { error }
});

export function deleteRoom (id){
  return dispatch => {
    dispatch(deleteRoomBegin());
    return fetch(API.DELETE_ROOM + id, GET_AUTH)
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(deleteRoomSuccess(id));
        dispatch(fetchAllRooms());
        return json;
      })
      .catch(error => dispatch(deleteRoomError(error.message)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/actions/deleteRoom.js